import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import api from "../_services/api";
import axios from "axios";
import { pedidosApi } from '../page/OrderResumePag/_services/api';
import { getWhitelabelFromMemory } from "../lib/sharedSessionMemory";

let cancelToken;
const channel = process.env.REACT_APP_DEFAULT_CHANNEL;

const getFatorFrete = () => {
  const configData = getWhitelabelFromMemory()?.config || {};
  const fatorFreteKey = `fator_${channel}_frete`;
  return configData[fatorFreteKey] / 10000 || 0;
};

export const getCart = createAsyncThunk(
  '/getCart',
  async ({ uuid, cep }) => {
  const fatorFrete = getFatorFrete();

  try {
    const zipCode = cep || '05424000';
    const response = await pedidosApi.get(`v2/carrinho/${channel}`, {
      params: { customerUuid: uuid, cep: zipCode, fator: fatorFrete },
    });

    if (response.status === 200) {
      const allItems = [];
      const shippingByBrand = {};

      Object.entries(response.data.data.items || {}).forEach(([cartId, cartData]) => {
        if (cartData.items) {
          allItems.push(...cartData.items);
          
          cartData.items.forEach(item => {
            const brandId = item.brand_uuid;
            if (!shippingByBrand[brandId]) {
              shippingByBrand[brandId] = {
                shipping_amount: cartData.deliveryOptions?.shippingPrice || 0,
                shipping_point: cartData.deliveryOptions?.shippingPoints || 0,
                shipping_deadline: cartData.deliveryOptions?.estimatedBusinessDays || 0
              };
            }
          })
        }
      })

      const groupedByBrand = allItems.reduce((accumulator, currentItem) => {
        const brandId = currentItem.brand_uuid;
        if (!accumulator[brandId]) {
          accumulator[brandId] = [];
        }
        accumulator[brandId].push(currentItem);
        return accumulator;
      }, {})

      const subtotal = allItems.reduce((total, item) => {
        const price = parseFloat(item.price?.BRL?.offer || item.price?.BRL?.price || 0);
        const quantity = parseInt(item.quantity || 1);
        return total + (price * quantity);
      }, 0)

      const shipping = Object.values(shippingByBrand)
        .reduce((total, shippingData) => total + parseFloat(shippingData.shipping_amount || 0), 0);

      const total = subtotal + shipping;

      const calculatedSummary = {
        subtotal: subtotal.toFixed(2),
        shipping: shipping.toFixed(2),
        total: total.toFixed(2),
      }

      const firstCartData = Object.values(response.data.data.items)[0] || {};
      
      const cart = {
        ...firstCartData,
        items: allItems,
        shipping_by_brand: shippingByBrand,
        summary: calculatedSummary
      }

      const ret = {
        cart,
        grouped: groupedByBrand,
        summary: calculatedSummary
      };
      return ret;

    }

    return { items: [] };

  } catch (err) {
    notify(err.response?.data?.message || 'Erro no carrinho', 'error');
    throw err;
  }

  },
  {

    condition: ({ force }, { getState }) => {

      if (force) {
        return true;
      }

      const { cartSlice } = getState();
      const { status } = cartSlice;

      if (status === 'succeeded' || status === 'loading') {
        return false;
      }

      return true;
    },
  }
);

export const removeItemCart = createAsyncThunk(
  "/removeItemCart",
  async ({ sku, uuid, cep }, thunkAPI) => {
    try {
      const fatorFrete = getFatorFrete();
      const res = await pedidosApi.delete(
        `v2/carrinho/${channel}`,
        {
          data: {
            customerUuid: uuid,
            sku: sku,
            cep: cep,
            fator: fatorFrete
          }
        }
      );

      thunkAPI.dispatch(getCart({ uuid, cep }));
      return true;

    } catch (err) {
      console.error("Erro ao remover item do carrinho:", err);
      return false;
    }

  }
);

export const changeQuantityItemCart = createAsyncThunk(
  "/changeQuantityItemCart",
  async ({ jsonCart, uuid, cep, action }, { dispatch, rejectWithValue }) => {

    try {
      if (typeof cancelToken != typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
      }
      cancelToken = axios.CancelToken.source();

      jsonCart.quantity = (action == 'add') ? +1 : -1;

      await pedidosApi.patch(
        `v2/carrinho/${channel}`,
        jsonCart
      )
      .then((res) => {
        dispatch(getCart({ uuid, cep }));
        return true;
      })
      .catch((err) => {
        return false;
      })

    } catch (error) {
      if (error.code === "ERR_CANCELED") {
        return;
      }
      return rejectWithValue({
        message: error.message,
        name: "error",
        code: "ERR_COMMON",
        status: 1,
      });
    }
  }
);

const assembleSlider = (items) => {
  let pontos_variavel = 0;
  let dinheiro_variavel = 0;
  let pontos_fixo = 0;
  let dinheiro_fixo = 0;
  items.map((item) => {
    const { quantity } = item;
    const dinheiro = item.price?.BRL?.price || 0;
    const pontos = item.price?.points?.points || 0;
    if (dinheiro > 0 && pontos > 0) {
      pontos_variavel += pontos * quantity;
      dinheiro_variavel += dinheiro * quantity;
    }
    if (dinheiro === 0 && pontos > 0) {
      pontos_fixo += pontos * quantity;
    }
    if (dinheiro > 0 && pontos === 0) {
      dinheiro_fixo += dinheiro * quantity;
    }
  });
  return {
    pontos_variavel: pontos_variavel,
    dinheiro_variavel: dinheiro_variavel,
    pontos_fixo: pontos_fixo,
    dinheiro_fixo: dinheiro_fixo,
  };
};

const initialState = {
  cart: { items: [] },
  loading: true,
  status: 'idle',
  payment_method: "dinheiro",
  slider: {
    pontos_variavel: 0,
    dinheiro_variavel: 0,
    pontos_fixo: 0,
    dinheiro_fixo: 0,
  },
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addCart: (state, action) => {
      state.cart = action.payload;
    },
    delCart: (state, action) => {
      state.cart = {};
    },
    setLoading: (state, action) => {
      state.loading = action.payload.value;
    },
    setPaymentMethod: (state, action) => {
      state.payment_method = action.payload.value;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCart.fulfilled, (state, action) => {
      state.cart = action.payload.cart;
      state.cart.summary = action.payload.summary;
      state.slider = assembleSlider(state.cart.items);
      state.loading = false;
    });
    builder.addCase(getCart.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  addCart,
  delCart,
  setLoading,
  setPaymentMethod,
  setShippingAmount,
} = cartSlice.actions;

export const selectCart = (state) => state.cartSlice.cart;
export const totalItens = (state) => {
  const items = state.cartSlice.cart?.items;
  if (!items?.length) return null;
  const sum = items.reduce(
    (acc, item) => acc + (parseInt(item.quantity, 10) || 1),
    0
  );
  return sum > 0 ? sum : null;
};
export const getSlider = (state) => state.cartSlice.slider;

export default cartSlice.reducer;
